import { QRCodeSVG } from "qrcode.react";

export default function OneKiteQR({ value, size = 200 }) {
  if (!value)
    return (
      <div
        style={{ width: size, height: size }}
        className="rounded-2xl bg-muted animate-pulse mx-auto"
      />
    );
  return (
    <div className="relative inline-flex p-4 bg-white rounded-2xl shadow-[0_8px_40px_rgba(52,211,153,0.25)]">
      <QRCodeSVG value={value} size={size} level="M" bgColor="#ffffff" fgColor="#07110c" />
    </div>
  );
}
